var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusylivingroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 38,
    viewBox: "0 0 41 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.91746 14.9598C5.00412 15.6498 3.79724 17.0298 3.09077 19.3098C2.91416 19.9098 3.00247 19.9998 3.82668 19.9998C6.41705 19.9998 8.8308 22.4898 8.8308 25.1298C8.8308 25.6398 8.97798 26.2998 9.12516 26.6298C9.41952 27.1698 9.80219 27.1998 14.718 27.1998C20.5758 27.1998 20.6052 27.1998 20.6052 25.0998C20.6052 22.4598 23.0484 19.9998 25.6388 19.9998C26.4336 19.9998 26.5219 19.9098 26.3452 19.3098C25.6388 16.9698 24.4319 15.6498 22.4008 14.9298C21.1056 14.5098 8.15377 14.5098 6.91746 14.9598Z",
    fill: "#168AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06052 21.7399C-0.559287 23.0599 -0.529851 27.4999 2.08996 28.4899C2.91417 28.8199 2.9436 28.8799 2.9436 30.8899C2.9436 33.1999 3.47345 34.6999 4.56259 35.4199C5.00413 35.7199 5.29849 36.2299 5.35736 36.8599L5.44567 37.8499H7.65337C9.83164 37.8499 9.86107 37.8499 9.94938 37.0099L10.0377 36.1999H14.718H19.3984L19.4867 37.0099C19.575 37.8499 19.6044 37.8499 21.7827 37.8499H23.9904L24.0787 36.8599C24.1376 36.2299 24.4319 35.7199 24.8735 35.4199C25.9626 34.6999 26.4924 33.1999 26.4924 30.8899C26.4924 28.8799 26.5219 28.8199 27.3461 28.4899C28.553 28.0399 29.2889 26.7499 29.2889 25.0699C29.2889 23.2699 28.4941 22.0999 26.8457 21.4999C25.7565 21.1099 25.4622 21.1099 24.373 21.4999C22.8129 22.0699 22.1359 23.0299 21.7827 25.2199C21.6061 26.3299 21.2528 27.2599 20.8702 27.7099C20.2226 28.3999 20.1048 28.3999 14.718 28.3999C9.33123 28.3999 9.21348 28.3999 8.56589 27.7099C8.18322 27.2599 7.82999 26.3299 7.65337 25.2499C7.30014 23.1199 6.74085 22.1899 5.44567 21.6199C4.12104 21.0799 3.29684 21.0799 2.06052 21.7399Z",
    fill: "#168AF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.436,
    height: 30,
    fill: "white",
    transform: "translate(0 7.99988)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusylivingroom);
export default __webpack_public_path__ + "static/media/busylivingroom.e15a205d6ef021351ed0c057efa42beb.svg";
export { ForwardRef as ReactComponent };